import PackageNeverArrived from './PackageNeverArrived';
import { withI18n } from 'react-i18next';

export default withI18n()(PackageNeverArrived);
